<!-- 日志的时长与大小Tip -->
<div [id]="tipId" [class.hidden]="hidden" class="inline-flex">
    <!-- 时长 -->
    <span class="simple-time-img"></span>
    <span>{{exportLog.time}}</span>
    <!-- 大小 -->
    <span class="storage-size-img"></span>
    <span >{{exportLog.size}}</span>
</div>
